<div
  class="relative mb-8 h-[186px] w-full overflow-hidden border-2 border-[var(--neutral-98)] dark:border-[var(--neutral-30)]">
  <div *ngIf="site$ | async as site" @slideRight class="relative z-10 flex h-full w-full flex-col justify-center pl-5">
    <p class="mb-2 text-md font-normal leading-5 text-[var(--neutral-50)]">{{ 'dashboard.welcome' | translate }}</p>
    <p class="text-[45px] font-light leading-[52px] text-[var(--neutral-0)] dark:text-[var(--neutral-98)]">
      {{ site.name }}
    </p>
  </div>

  <div class="absolute right-[124px] top-0 z-0" @slideDown>
    <ng-container *ngTemplateOutlet="logoHeaderTopLeft"></ng-container>
  </div>

  <div class="absolute right-0 top-0 z-0" @slideDown2>
    <ng-container *ngTemplateOutlet="logoHeaderTopRight"></ng-container>
  </div>

  <div class="absolute bottom-[-5px] right-[25px] z-0" @slideUp>
    <ng-container *ngTemplateOutlet="logoHeaderBottomRight"></ng-container>
  </div>

  <div class="absolute bottom-[-5px] right-[220px] z-0" @slideUp2>
    <ng-container *ngTemplateOutlet="logoHeaderBottomLeft"></ng-container>
  </div>
</div>

<ng-template #logoHeaderTopLeft>
  @if (isDarkMode | async) {
    <svg width="182" height="117" viewBox="0 0 182 117" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.4">
        <path
          d="M90.9296 117.001V12.0066L0 -40.4961V-29.2086L81.1499 17.6451L81.1602 111.363L90.9296 117.001Z"
          fill="#7B8593" />
        <path
          d="M172.086 -34.8574V58.8604L100.695 17.6451L100.706 28.9325L172.086 70.1477L181.856 64.5092V-40.4961L172.086 -34.8574Z"
          fill="#7B8593" />
        <path
          d="M172.09 -23.572V-34.8594L162.31 -29.2209L90.9297 11.9944V117L100.709 111.351V17.6432L172.09 58.8584V47.5709V-23.572ZM162.31 -17.9231V41.9221L110.489 11.9944L162.31 -17.9231Z"
          fill="#8D96A2" />
        <path
          d="M181.859 -40.4976L172.09 -46.1465L90.9296 0.717587L9.76946 -46.1465L0 -40.4976L90.9296 12.0051L181.859 -40.4976Z"
          fill="#A8AFB8" />
        <path
          d="M162.31 -40.4978L90.9297 -81.7129V0.717407L100.699 -4.93144V-64.787L152.541 -34.8592L162.31 -40.4978Z"
          fill="#393F46" />
        <path d="M9.77344 58.8601L19.5531 53.2111V-17.9215L9.77344 -23.5703V58.8601Z" fill="#505862" />
        <path d="M19.5469 41.9238L71.3782 11.9961L81.1476 17.6449L19.5469 53.2112V41.9238Z" fill="#393F46" />
        <path
          d="M81.1499 100.073L9.76945 58.858V-23.5724L0 -29.2109V64.5069L81.1602 111.361L81.1499 100.073Z"
          fill="#454B54" />
        <path d="M9.77344 58.8599L81.1539 100.075V88.7876L19.5531 53.2109L9.77344 58.8599Z" fill="#393F46" />
        <path
          d="M100.711 100.074V111.362L162.58 75.6406L152.811 70.002L100.721 100.085L100.711 100.074Z"
          fill="#454B54" />
        <path d="M100.695 88.7873V100.075L152.795 69.992L143.026 64.3535L100.706 88.7873H100.695Z" fill="#393F46" />
        <path d="M29.3265 58.8597L19.5469 53.2108L81.1476 17.6445V28.9319L29.3265 58.8597Z" fill="#454B54" />
        <path
          d="M90.9343 -81.7129L29.0547 -45.9917L38.8345 -40.3429L81.1546 -64.7767L81.165 -4.93144L90.9343 0.717407V-81.7129Z"
          fill="#505862" />
      </g>
    </svg>
  } @else {
    <svg width="182" height="117" viewBox="0 0 182 117" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.4">
        <path
          d="M90.9296 117.001V12.0066L0 -40.4961V-29.2086L81.1499 17.6451L81.1602 111.363L90.9296 117.001Z"
          fill="#7B8593" />
        <path
          d="M172.086 -34.8574V58.8604L100.695 17.6451L100.706 28.9325L172.086 70.1477L181.856 64.5092V-40.4961L172.086 -34.8574Z"
          fill="#7B8593" />
        <path
          d="M172.09 -23.572V-34.8594L162.31 -29.2209L90.9297 11.9944V117L100.709 111.351V17.6432L172.09 58.8584V47.5709V-23.572ZM162.31 -17.9231V41.9221L110.489 11.9944L162.31 -17.9231Z"
          fill="#8D96A2" />
        <path
          d="M181.859 -40.4976L172.09 -46.1465L90.9296 0.717587L9.76946 -46.1465L0 -40.4976L90.9296 12.0051L181.859 -40.4976Z"
          fill="#A8AFB8" />
        <path
          d="M162.31 -40.4978L90.9297 -81.7129V0.717407L100.699 -4.93144V-64.787L152.541 -34.8592L162.31 -40.4978Z"
          fill="#B6BCC4" />
        <path d="M9.77344 58.8601L19.5531 53.2111V-17.9215L9.77344 -23.5703V58.8601Z" fill="#C6CAD0" />
        <path d="M19.5469 41.9238L71.3782 11.9961L81.1476 17.6449L19.5469 53.2112V41.9238Z" fill="#B6BCC4" />
        <path
          d="M81.1499 100.073L9.76945 58.858V-23.5724L0 -29.2109V64.5069L81.1602 111.361L81.1499 100.073Z"
          fill="#D3D6DB" />
        <path d="M9.77344 58.8599L81.1539 100.075V88.7876L19.5531 53.2109L9.77344 58.8599Z" fill="#B6BCC4" />
        <path
          d="M100.711 100.074V111.362L162.58 75.6406L152.811 70.002L100.721 100.085L100.711 100.074Z"
          fill="#D3D6DB" />
        <path d="M100.695 88.7873V100.075L152.795 69.992L143.026 64.3535L100.706 88.7873H100.695Z" fill="#B6BCC4" />
        <path d="M29.3265 58.8597L19.5469 53.2108L81.1476 17.6445V28.9319L29.3265 58.8597Z" fill="#D3D6DB" />
        <path
          d="M90.9343 -81.7129L29.0547 -45.9917L38.8345 -40.3429L81.1546 -64.7767L81.165 -4.93144L90.9343 0.717407V-81.7129Z"
          fill="#C6CAD0" />
      </g>
    </svg>
  }
</ng-template>

<ng-template #logoHeaderTopRight>
  @if (isDarkMode | async) {
    <svg width="109" height="117" viewBox="0 0 109 117" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.2">
        <path
          d="M91.7889 117.001V12.0066L0.859375 -40.4961V-29.2086L82.0093 17.6451L82.0196 111.363L91.7889 117.001Z"
          fill="#7B8593" />
        <path
          d="M172.945 -34.8574V58.8604L101.555 17.6451L101.565 28.9325L172.945 70.1477L182.715 64.5092V-40.4961L172.945 -34.8574Z"
          fill="#7B8593" />
        <path
          d="M172.949 -23.572V-34.8594L163.169 -29.2209L91.7891 11.9944V117L101.569 111.351V17.6432L172.949 58.8584V47.5709V-23.572ZM163.169 -17.9231V41.9221L111.348 11.9944L163.169 -17.9231Z"
          fill="#8D96A2" />
        <path
          d="M182.718 -40.4976L172.949 -46.1465L91.7889 0.717587L10.6288 -46.1465L0.859375 -40.4976L91.7889 12.0051L182.718 -40.4976Z"
          fill="#A8AFB8" />
        <path
          d="M163.169 -40.4978L91.7891 -81.7129V0.717407L101.558 -4.93144V-64.787L153.4 -34.8592L163.169 -40.4978Z"
          fill="#393F46" />
        <path d="M10.6328 58.8601L20.4125 53.2111V-17.9215L10.6328 -23.5703V58.8601Z" fill="#505862" />
        <path d="M20.4062 41.9238L72.2375 11.9961L82.007 17.6449L20.4062 53.2112V41.9238Z" fill="#393F46" />
        <path
          d="M82.0093 100.073L10.6288 58.858V-23.5724L0.859375 -29.2109V64.5069L82.0196 111.361L82.0093 100.073Z"
          fill="#454B54" />
        <path d="M10.6328 58.8599L82.0132 100.075V88.7876L20.4125 53.2109L10.6328 58.8599Z" fill="#393F46" />
        <path d="M101.57 100.074V111.362L163.44 75.6406L153.67 70.002L101.581 100.085L101.57 100.074Z" fill="#454B54" />
        <path d="M101.555 88.7873V100.075L153.655 69.992L143.885 64.3535L101.565 88.7873H101.555Z" fill="#393F46" />
        <path d="M30.1859 58.8597L20.4062 53.2108L82.007 17.6445V28.9319L30.1859 58.8597Z" fill="#454B54" />
        <path
          d="M91.7937 -81.7129L29.9141 -45.9917L39.6939 -40.3429L82.014 -64.7767L82.0243 -4.93144L91.7937 0.717407V-81.7129Z"
          fill="#505862" />
      </g>
    </svg>
  } @else {
    <svg width="109" height="117" viewBox="0 0 109 117" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.3">
        <path
          d="M91.7889 117.001V12.0066L0.859375 -40.4961V-29.2086L82.0093 17.6451L82.0196 111.363L91.7889 117.001Z"
          fill="#7B8593" />
        <path
          d="M172.945 -34.8574V58.8604L101.555 17.6451L101.565 28.9325L172.945 70.1477L182.715 64.5092V-40.4961L172.945 -34.8574Z"
          fill="#7B8593" />
        <path
          d="M172.949 -23.572V-34.8594L163.169 -29.2209L91.7891 11.9944V117L101.569 111.351V17.6432L172.949 58.8584V47.5709V-23.572ZM163.169 -17.9231V41.9221L111.348 11.9944L163.169 -17.9231Z"
          fill="#8D96A2" />
        <path
          d="M182.718 -40.4976L172.949 -46.1465L91.7889 0.717587L10.6288 -46.1465L0.859375 -40.4976L91.7889 12.0051L182.718 -40.4976Z"
          fill="#A8AFB8" />
        <path
          d="M163.169 -40.4978L91.7891 -81.7129V0.717407L101.558 -4.93144V-64.787L153.4 -34.8592L163.169 -40.4978Z"
          fill="#B6BCC4" />
        <path d="M10.6328 58.8601L20.4125 53.2111V-17.9215L10.6328 -23.5703V58.8601Z" fill="#C6CAD0" />
        <path d="M20.4062 41.9238L72.2375 11.9961L82.007 17.6449L20.4062 53.2112V41.9238Z" fill="#B6BCC4" />
        <path
          d="M82.0093 100.073L10.6288 58.858V-23.5724L0.859375 -29.2109V64.5069L82.0196 111.361L82.0093 100.073Z"
          fill="#D3D6DB" />
        <path d="M10.6328 58.8599L82.0132 100.075V88.7876L20.4125 53.2109L10.6328 58.8599Z" fill="#B6BCC4" />
        <path d="M101.57 100.074V111.362L163.44 75.6406L153.67 70.002L101.581 100.085L101.57 100.074Z" fill="#D3D6DB" />
        <path d="M101.555 88.7873V100.075L153.655 69.992L143.885 64.3535L101.565 88.7873H101.555Z" fill="#B6BCC4" />
        <path d="M30.1859 58.8597L20.4062 53.2108L82.007 17.6445V28.9319L30.1859 58.8597Z" fill="#D3D6DB" />
        <path
          d="M91.7937 -81.7129L29.9141 -45.9917L39.6939 -40.3429L82.014 -64.7767L82.0243 -4.93144L91.7937 0.717407V-81.7129Z"
          fill="#C6CAD0" />
      </g>
    </svg>
  }
</ng-template>

<ng-template #logoHeaderBottomLeft>
  @if (isDarkMode | async) {
    <svg width="182" height="113" viewBox="0 0 182 113" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.8">
        <path
          d="M91.0708 0L19.4219 41.3701L29.1912 47.0087L91.0708 11.2875L162.451 52.5026L172.231 46.8537L91.0708 0Z"
          fill="#454B54" />
        <path
          d="M91.0702 210.001V105.007L0.140625 52.5039V63.7914L81.2905 110.645L81.3008 204.363L91.0702 210.001Z"
          fill="#7B8593" />
        <path
          d="M172.227 58.1426V151.86L100.836 110.645L100.846 121.933L172.227 163.148L181.996 157.509V52.5039L172.227 58.1426Z"
          fill="#7B8593" />
        <path
          d="M172.23 69.428V58.1406L162.451 63.7791L91.0703 104.994V210L100.85 204.351V110.643L172.23 151.858V140.571V69.428ZM162.451 75.0769V134.922L110.63 104.994L162.451 75.0769Z"
          fill="#8D96A2" />
        <path
          d="M182 52.5024L172.23 46.8535L91.0702 93.7176L9.91008 46.8535L0.140625 52.5024L91.0702 105.005L182 52.5024Z"
          fill="#A8AFB8" />
        <path
          d="M162.451 52.5022L91.0703 11.2871V93.7174L100.84 88.0686V28.213L152.681 58.1408L162.451 52.5022Z"
          fill="#393F46" />
        <path d="M9.91406 151.86L19.6937 146.211V75.0785L9.91406 69.4297V151.86Z" fill="#505862" />
        <path d="M19.6875 134.924L71.5188 104.996L81.2883 110.645L19.6875 146.211V134.924Z" fill="#393F46" />
        <path
          d="M81.2905 193.073L9.91008 151.858V69.4276L0.140625 63.7891V157.507L81.3008 204.361L81.2905 193.073Z"
          fill="#454B54" />
        <path d="M29.4672 151.86L19.6875 146.211L81.2883 110.645V121.932L29.4672 151.86Z" fill="#454B54" />
        <path
          d="M91.0749 11.2871L29.1953 47.0083L38.9751 52.6571L81.2953 28.2233L81.3056 88.0686L91.0749 93.7174V11.2871Z"
          fill="#505862" />
      </g>
    </svg>
  } @else {
    <svg width="182" height="113" viewBox="0 0 182 113" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.8">
        <path
          d="M91.0708 0L19.4219 41.3701L29.1912 47.0087L91.0708 11.2875L162.451 52.5026L172.231 46.8537L91.0708 0Z"
          fill="#D3D6DB" />
        <path
          d="M91.0702 210.001V105.007L0.140625 52.5039V63.7914L81.2905 110.645L81.3008 204.363L91.0702 210.001Z"
          fill="#7B8593" />
        <path
          d="M172.227 58.1426V151.86L100.836 110.645L100.846 121.933L172.227 163.148L181.996 157.509V52.5039L172.227 58.1426Z"
          fill="#7B8593" />
        <path
          d="M172.23 69.428V58.1406L162.451 63.7791L91.0703 104.994V210L100.85 204.351V110.643L172.23 151.858V140.571V69.428ZM162.451 75.0769V134.922L110.63 104.994L162.451 75.0769Z"
          fill="#8D96A2" />
        <path
          d="M182 52.5024L172.23 46.8535L91.0702 93.7176L9.91008 46.8535L0.140625 52.5024L91.0702 105.005L182 52.5024Z"
          fill="#A8AFB8" />
        <path
          d="M162.451 52.5022L91.0703 11.2871V93.7174L100.84 88.0686V28.213L152.681 58.1408L162.451 52.5022Z"
          fill="#B6BCC4" />
        <path d="M9.91406 151.86L19.6937 146.211V75.0785L9.91406 69.4297V151.86Z" fill="#C6CAD0" />
        <path d="M19.6875 134.924L71.5188 104.996L81.2883 110.645L19.6875 146.211V134.924Z" fill="#B6BCC4" />
        <path
          d="M81.2905 193.073L9.91008 151.858V69.4276L0.140625 63.7891V157.507L81.3008 204.361L81.2905 193.073Z"
          fill="#D3D6DB" />
        <path d="M29.4672 151.86L19.6875 146.211L81.2883 110.645V121.932L29.4672 151.86Z" fill="#D3D6DB" />
        <path
          d="M91.0749 11.2871L29.1953 47.0083L38.9751 52.6571L81.2953 28.2233L81.3056 88.0686L91.0749 93.7174V11.2871Z"
          fill="#C6CAD0" />
      </g>
    </svg>
  }
</ng-template>

<ng-template #logoHeaderBottomRight>
  @if (isDarkMode | async) {
    <svg width="182" height="113" viewBox="0 0 182 113" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.4">
        <path
          d="M90.9302 0L19.2812 41.3701L29.0506 47.0087L90.9302 11.2875L162.311 52.5026L172.09 46.8537L90.9302 0Z"
          fill="#454B54" />
        <path d="M90.9296 210V105.005L0 52.502V63.7895L81.1499 110.643L81.1602 204.361L90.9296 210Z" fill="#7B8593" />
        <path
          d="M172.086 58.1406V151.858L100.695 110.643L100.706 121.931L172.086 163.146L181.856 157.507V52.502L172.086 58.1406Z"
          fill="#7B8593" />
        <path
          d="M172.09 69.428V58.1406L162.31 63.7791L90.9297 104.994V210L100.709 204.351V110.643L172.09 151.858V140.571V69.428ZM162.31 75.0769V134.922L110.489 104.994L162.31 75.0769Z"
          fill="#8D96A2" />
        <path
          d="M181.859 52.5024L172.09 46.8535L90.9296 93.7176L9.76946 46.8535L0 52.5024L90.9296 105.005L181.859 52.5024Z"
          fill="#A8AFB8" />
        <path
          d="M162.31 52.5022L90.9297 11.2871V93.7174L100.699 88.0686V28.213L152.541 58.1408L162.31 52.5022Z"
          fill="#393F46" />
        <path d="M9.77344 151.86L19.5531 146.211V75.0785L9.77344 69.4297V151.86Z" fill="#505862" />
        <path d="M19.5469 134.922L71.3782 104.994L81.1476 110.643L19.5469 146.209V134.922Z" fill="#393F46" />
        <path
          d="M81.1499 193.073L9.76945 151.858V69.4276L0 63.7891V157.507L81.1602 204.361L81.1499 193.073Z"
          fill="#454B54" />
        <path d="M29.3265 151.858L19.5469 146.209L81.1476 110.643V121.93L29.3265 151.858Z" fill="#454B54" />
        <path
          d="M90.9343 11.2871L29.0547 47.0083L38.8345 52.6571L81.1546 28.2233L81.165 88.0686L90.9343 93.7174V11.2871Z"
          fill="#505862" />
      </g>
    </svg>
  } @else {
    <svg width="182" height="113" viewBox="0 0 182 113" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.4">
        <path
          d="M90.9302 0L19.2812 41.3701L29.0506 47.0087L90.9302 11.2875L162.311 52.5026L172.09 46.8537L90.9302 0Z"
          fill="#D3D6DB" />
        <path d="M90.9296 210V105.005L0 52.502V63.7895L81.1499 110.643L81.1602 204.361L90.9296 210Z" fill="#7B8593" />
        <path
          d="M172.086 58.1406V151.858L100.695 110.643L100.706 121.931L172.086 163.146L181.856 157.507V52.502L172.086 58.1406Z"
          fill="#7B8593" />
        <path
          d="M172.09 69.428V58.1406L162.31 63.7791L90.9297 104.994V210L100.709 204.351V110.643L172.09 151.858V140.571V69.428ZM162.31 75.0769V134.922L110.489 104.994L162.31 75.0769Z"
          fill="#8D96A2" />
        <path
          d="M181.859 52.5024L172.09 46.8535L90.9296 93.7176L9.76946 46.8535L0 52.5024L90.9296 105.005L181.859 52.5024Z"
          fill="#A8AFB8" />
        <path
          d="M162.31 52.5022L90.9297 11.2871V93.7174L100.699 88.0686V28.213L152.541 58.1408L162.31 52.5022Z"
          fill="#B6BCC4" />
        <path d="M9.77344 151.86L19.5531 146.211V75.0785L9.77344 69.4297V151.86Z" fill="#C6CAD0" />
        <path d="M19.5469 134.922L71.3782 104.994L81.1476 110.643L19.5469 146.209V134.922Z" fill="#B6BCC4" />
        <path
          d="M81.1499 193.073L9.76945 151.858V69.4276L0 63.7891V157.507L81.1602 204.361L81.1499 193.073Z"
          fill="#D3D6DB" />
        <path d="M29.3265 151.858L19.5469 146.209L81.1476 110.643V121.93L29.3265 151.858Z" fill="#D3D6DB" />
        <path
          d="M90.9343 11.2871L29.0547 47.0083L38.8345 52.6571L81.1546 28.2233L81.165 88.0686L90.9343 93.7174V11.2871Z"
          fill="#C6CAD0" />
      </g>
    </svg>
  }
</ng-template>
